<template>
    <!-- 无权限锁定页 -->
    <div v-if="!hasPermission" class="dev-lock">
        <div class="dev-lock-card">
            <i class="el-icon-lock"></i>
            <div class="dev-lock-title">代理后台</div>
            <div class="dev-lock-desc">您暂无代理权限，请联系客服开通</div>
            <el-button type="primary" round @click="$router.push('/user2/index')">返回首页</el-button>
        </div>
    </div>

    <div v-else class="dev-container">
        <div class="dev-switch-cards">
            <button v-for="item in sectionTabs" :key="item.key" type="button" class="dev-switch-card"
                :class="{ active: activeSection === item.key }" @click="switchSection(item.key)">
                <app-icon  class="app-icon" :name="item.icon"></app-icon>
                <span>{{ item.name }}</span>
            </button>
        </div>
        <div class="dev-switch-hint">
            <i class="el-icon-back"></i>
            <span>左右滑动查看更多</span>
            <i class="el-icon-right"></i>
        </div>

        <div v-show="activeSection === 'dashboard'" class="dev-panel">
        <!-- 数据面板 -->
        <div class="dev-section-title">数据面板</div>
        <div class="dev-stats-grid">
            <div class="dev-stat-card" v-for="(item, index) in viewdata" :key="index">
                <div class="dev-stat-value" :style="{ color: item.color }">
                    {{ formatNumber(proxy_info[item.num_key] || 0) }}
                </div>
                <div class="dev-stat-label">{{ item.name }}</div>
            </div>
        </div>
        </div>

        <div v-show="activeSection === 'info'" class="dev-panel">
        <!-- 代理信息 -->
        <div class="dev-section-title">信息配置</div>
        <div class="dev-card">
            <div class="dev-info-row">
                <div class="dev-info-label">软件名称</div>
                <div class="dev-info-value">{{ proxy_info.app_name || '-' }}</div>
            </div>
            <div class="dev-info-row">
                <div class="dev-info-label">代理状态</div>
                <div class="dev-info-value">
                    <span class="dev-status-dot" :class="proxy_info.status === 1 ? 'dot-green' : 'dot-gray'"></span>
                    {{ proxy_info.status === 1 ? '正常' : '异常' }}
                </div>
            </div>
            <div class="dev-info-row">
                <div class="dev-info-label">账户余额</div>
                <div class="dev-info-value"><span class="dev-highlight">{{ balance }}</span> 元</div>
            </div>
            <div class="dev-info-row">
                <div class="dev-info-label">结算比例</div>
                <div class="dev-info-value">{{ settlementRate }}%</div>
            </div>

            <div class="dev-info-row" v-if="!isExchangeCodeProxy">
                <div class="dev-info-label">首页图片</div>
                <div class="dev-info-value">
                    <div v-if="!proxy_info.homepage">
                        <el-button size="mini" type="primary" plain @click="openImageUpload('homepage', 5)">立即设置</el-button>
                    </div>
                    <div v-else class="dev-images">
                        <el-image v-for="(item, index) in proxy_info.homepage" :key="index" class="dev-thumb"
                            :src="item" fit="cover" :preview-src-list="proxy_info.homepage" />
                        <el-link type="primary" @click="openImageUpload('homepage', 5)">修改</el-link>
                    </div>
                </div>
            </div>

            <div class="dev-info-row" v-if="!isExchangeCodeProxy">
                <div class="dev-info-label">客服图片</div>
                <div class="dev-info-value">
                    <div v-if="!proxy_info.kf">
                        <el-button size="mini" type="primary" plain @click="openImageUpload('kf', 1)">立即设置</el-button>
                    </div>
                    <div v-else class="dev-images">
                        <el-image class="dev-thumb-sm" :src="proxy_info.kf" fit="cover" :preview-src-list="[proxy_info.kf]" />
                        <el-link type="primary" @click="openImageUpload('kf', 1)">修改</el-link>
                    </div>
                </div>
            </div>

            <div class="dev-info-row" v-if="!isExchangeCodeProxy" style="align-items: flex-start;">
                <div class="dev-info-label" style="padding-top: 12px;">推广佣金</div>
                <div class="dev-info-value">
                    <div class="share-cards">
                        <div v-for="(item, index) in proxy_info.share_list" :key="index" class="share-card">
                        <div class="share-card-header">
                            <span class="share-card-name">{{ item.name || '等级' + (index + 1) }}</span>
                            <el-button type="danger" size="mini" icon="el-icon-delete" circle plain @click="delShareRule(item)" />
                        </div>
                        <div class="share-card-body">
                            <div class="share-stat">
                                <span class="share-stat-value">{{ item.people }}</span>
                                <span class="share-stat-label">生效人数</span>
                            </div>
                            <span class="share-stat-divider"></span>
                            <div class="share-stat">
                                <span class="share-stat-value">{{ (item.share1_fl * 100).toFixed(1) }}%</span>
                                <span class="share-stat-label">一级返利</span>
                            </div>
                            <span class="share-stat-divider"></span>
                            <div class="share-stat">
                                <span class="share-stat-value">{{ (item.share2_fl * 100).toFixed(1) }}%</span>
                                <span class="share-stat-label">二级返利</span>
                            </div>
                        </div>
                    </div>
                    </div>
                    <el-button size="small" type="primary" plain icon="el-icon-plus" @click="share_set = true" class="share-add-btn">添加规则</el-button>
                </div>
            </div>
        </div>
        </div>

        <div v-show="activeSection === 'cdk'" class="dev-panel">
        <!-- 兑换码已独立为单独页面，此处只做开通与跳转 -->
        <div class="dev-section-title">兑换码</div>
        <div class="dev-card">
            <div class="dev-tip" style="margin-top: 0;">
                兑换码的购买、记录与批量兑换已独立为单独页面，代理用户与批发用户共用同一个入口。
            </div>
            <div class="dev-form-row" style="margin-top: 18px;">
                <el-button v-if="cdkActivated" type="primary" @click="goToBuyCdk">前往购买兑换码</el-button>
                <el-button v-else-if="cdkCanActivate" type="primary" :loading="cdkActivating"
                    @click="activateCdk">开通兑换码权限</el-button>
                <span v-else class="dev-tip" style="margin: 0;">暂不可开通，请联系管理员</span>
            </div>
        </div>
        </div>

        <div v-show="activeSection === 'records'" class="dev-panel">
        <!-- 记录列表 -->
        <div class="dev-section-title">记录列表</div>
        <el-tabs v-model="activeName" @tab-click="handleTabClick" class="dev-tabs">
            <el-tab-pane label="用户记录" name="user_list">
                <div class="dev-card">
                    <div class="record-search">
                        <el-input v-model="userKeyword" maxlength="100" clearable size="small" placeholder="手机号 / 用户名 / 用户 ID" prefix-icon="el-icon-search" @keyup.enter.native="searchRecords" @clear="searchRecords" />
                        <el-button size="small" type="primary" @click="searchRecords">搜索</el-button>
                    </div>
                    <el-table :data="recordRows" size="mini" v-loading="loading"
                        :header-cell-style="{ background: '#fafafa', color: '#8c8c8c', fontWeight: 500, borderBottom: '1px solid #f0f0f0' }"
                        :cell-style="{ borderBottom: '1px solid #f5f5f5', color: '#262626' }">
                        <el-table-column prop="id" label="用户 ID" width="90" />
                        <el-table-column prop="username" label="用户名(点击可复制)" width="160">
                            <template slot-scope="scope">
                                <span class="dev-link" @click="copyText(scope.row.username)">{{ scope.row.username || '无用户名' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="phone" label="手机号">
                            <template slot-scope="scope">{{ scope.row.phone || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="来源">
                            <template slot-scope="scope">
                                <span class="dev-tag-blue" v-if="scope.row.openid">微信</span>
                                <span class="dev-tag-gray" v-else>官网</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                <span class="dev-status-dot" :class="scope.row.status === 1 ? 'dot-green' : 'dot-gray'"></span>
                                {{ scope.row.status === 1 ? '正常' : '异常' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="余额(元)" min-width="100"><template slot-scope="scope">¥{{ formatNumber(scope.row.balance) }}</template></el-table-column>
                        <el-table-column label="返利余额(元)" min-width="120"><template slot-scope="scope">¥{{ formatNumber(scope.row.yqfl) }}</template></el-table-column>
                        <el-table-column label="操作" width="110" fixed="right"><template slot-scope="scope"><el-button size="mini" type="danger" plain :disabled="Number(scope.row.balance || 0) <= 0 || Number(scope.row.yqfl || 0) <= 0" @click="openDeductDialog(scope.row)">扣除余额</el-button></template></el-table-column>
                        <el-table-column prop="intime" label="注册日期" :formatter="formatDate" />
                    </el-table>
                    <el-pagination small layout="total, prev, pager, next" :page-size="pageSize" :total="total"
                        @current-change="handlePageChange" :current-page="recordPage" class="dev-pagination" />
                </div>
            </el-tab-pane>

            <el-tab-pane label="充值记录" name="pay_list">
                <div class="dev-card">
                    <div class="record-search">
                        <el-input v-model="payKeyword" maxlength="100" clearable size="small" placeholder="手机号 / 用户名 / 用户 ID" prefix-icon="el-icon-search" @keyup.enter.native="searchRecords" @clear="searchRecords" />
                        <el-button size="small" type="primary" @click="searchRecords">搜索</el-button>
                    </div>
                    <div class="record-filters">
                        <el-select v-model="payMethod" size="small" clearable placeholder="支付方式" style="width: 130px;" @change="searchRecords">
                            <el-option label="支付宝" value="1" />
                            <el-option label="微信" value="2" />
                            <el-option label="苹果内购" value="0" />
                        </el-select>
                        <el-select v-model="payStatus" size="small" clearable placeholder="状态" style="width: 110px;" @change="searchRecords">
                            <el-option label="已付款" value="1" />
                            <el-option label="未付款" value="0" />
                        </el-select>
                        <el-date-picker v-model="payRange" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                            size="small" style="width: 250px;" @change="searchRecords" />
                        <el-button size="small" @click="resetPayFilters">重置</el-button>
                    </div>
                    <el-table :data="recordRows" size="mini" v-loading="loading"
                        :header-cell-style="{ background: '#fafafa', color: '#8c8c8c', fontWeight: 500, borderBottom: '1px solid #f0f0f0' }"
                        :cell-style="{ borderBottom: '1px solid #f5f5f5', color: '#262626' }">
                        <el-table-column prop="uid" label="用户 ID" width="90" />
                        <el-table-column prop="username" label="用户名" width="120">
                            <template slot-scope="scope">
                                <span class="dev-link" @click="copyText(scope.row.username)">{{ scope.row.username }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ordernum" label="订单号" width="160" />
                        <el-table-column prop="je" label="金额" width="80">
                            <template slot-scope="scope">
                                <span style="font-weight: 500;">¥{{ scope.row.je }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shopname" label="套餐名" />
                        <el-table-column label="支付方式">
                            <template slot-scope="scope">
                                {{ payMethodName(scope.row.method) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                <span class="dev-status-dot" :class="scope.row.status === 1 ? 'dot-green' : 'dot-gray'"></span>
                                {{ scope.row.status === 1 ? '已付款' : '未付款' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="intime" label="日期" :formatter="formatDate" width="140" />
                    </el-table>
                    <el-pagination small layout="total, prev, pager, next" :page-size="pageSize" :total="total"
                        @current-change="handlePageChange" :current-page="recordPage" class="dev-pagination" />
                </div>
            </el-tab-pane>
            <el-tab-pane label="扣款记录" name="deduction_list">
                <div class="dev-card">
                    <div class="record-search"><el-input v-model="deductionKeyword" maxlength="100" clearable size="small" placeholder="被扣用户的手机号 / 用户名 / 用户 ID" prefix-icon="el-icon-search" @keyup.enter.native="searchRecords" @clear="searchRecords" /><el-button size="small" type="primary" @click="searchRecords">搜索</el-button></div>
                    <el-table :data="recordRows" size="mini" v-loading="loading" empty-text="暂无扣款记录">
                        <el-table-column prop="uid" label="用户 ID" width="90" />
                        <el-table-column prop="username" label="被扣用户" min-width="130" />
                        <el-table-column prop="proxy_name" label="所属小程序" min-width="120" />
                        <el-table-column label="扣除金额" width="110"><template slot-scope="scope"><strong class="deduction-amount">¥{{ formatNumber(scope.row.amount) }}</strong></template></el-table-column>
                        <el-table-column label="余额（前 → 后）" min-width="170"><template slot-scope="scope">¥{{ formatNumber(scope.row.balance_before) }} → ¥{{ formatNumber(scope.row.balance_after) }}</template></el-table-column>
                        <el-table-column label="返利余额（前 → 后）" min-width="180"><template slot-scope="scope">¥{{ formatNumber(scope.row.rebate_before) }} → ¥{{ formatNumber(scope.row.rebate_after) }}</template></el-table-column>
                        <el-table-column prop="intime" label="扣款时间" :formatter="formatDate" width="170" />
                    </el-table>
                    <el-pagination small layout="total, prev, pager, next" :page-size="pageSize" :total="total" @current-change="handlePageChange" :current-page="recordPage" class="dev-pagination" />
                </div>
            </el-tab-pane>
        </el-tabs>
        </div>

        <div v-show="activeSection === 'ads'" class="dev-panel">
        <!-- 广告收益列表 -->
        <div class="dev-section-title">广告列表</div>
        <div class="dev-card">
            <div class="ad-source" v-if="adSource">
                <el-tag size="small" type="primary">
                    {{ adSource === 'agency' ? '第三方平台代运营数据' : '小程序直连数据' }}
                </el-tag>
                <span>{{ adAppid }}</span>
            </div>
            <!-- 广告收益 / 广告信息 切换 -->
            <div class="ad-view-switch">
                <el-radio-group v-model="adView" size="small">
                    <el-radio-button label="income">广告收益</el-radio-button>
                    <el-radio-button label="info">广告信息</el-radio-button>
                </el-radio-group>
            </div>

            <div class="ad-error" v-if="adError">
                <i class="el-icon-warning-outline"></i>
                <span>{{ adError }}</span>
                <el-button size="mini" type="text" @click="handleAdSearch">重试</el-button>
            </div>

            <!-- 收益视图：每日汇总 + 广告位收益明细 -->
            <div v-show="adView === 'income'">
                <!-- 统计摘要 -->
                <div class="ad-summary" v-if="adSummary">
                    <div class="ad-summary-item">
                        <div class="ad-summary-value ad-income">{{ formatNumber((adSummary.income / 100).toFixed(2)) }}</div>
                        <div class="ad-summary-label">总收入(元)</div>
                    </div>
                    <div class="ad-summary-item">
                        <div class="ad-summary-value">{{ formatNumber(adSummary.exposure_count) }}</div>
                        <div class="ad-summary-label">曝光次数</div>
                    </div>
                    <div class="ad-summary-item">
                        <div class="ad-summary-value">{{ formatNumber(adSummary.click_count) }}</div>
                        <div class="ad-summary-label">点击次数</div>
                    </div>
                    <div class="ad-summary-item">
                        <div class="ad-summary-value">{{ (adSummary.click_rate * 100).toFixed(2) }}%</div>
                        <div class="ad-summary-label">点击率</div>
                    </div>
                    <div class="ad-summary-item">
                        <div class="ad-summary-value">{{ adSummary.ecpm.toFixed(2) }}</div>
                        <div class="ad-summary-label">ecpm</div>
                    </div>
                    <div class="ad-summary-item">
                        <div class="ad-summary-value">{{ formatNumber(adSummary.req_succ_count) }}</div>
                        <div class="ad-summary-label">请求成功</div>
                    </div>
                </div>

                <!-- 快捷日期 -->
                <div class="ad-quick-dates">
                    <span class="ad-quick-label">快捷：</span>
                    <el-button size="mini" :plain="adQuickDate !== 'yesterday'" type="primary" @click="setAdDateRange('yesterday')">昨天</el-button>
                    <el-button size="mini" :plain="adQuickDate !== 'month'" type="primary" @click="setAdDateRange('month')">本月</el-button>
                    <el-button size="mini" :plain="adQuickDate !== 'lastMonth'" type="primary" @click="setAdDateRange('lastMonth')">上个月</el-button>
                </div>

                <!-- 查询区域 -->
                <div class="ad-search">
                    <el-date-picker v-model="adDateRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                        size="small" style="width: 260px;" @change="adQuickDate = ''" />
                    <el-button size="small" type="primary" @click="handleAdSearch" style="margin-left: 8px;">查询</el-button>
                </div>

                <!-- 数据表格 -->
                <el-table :data="adList" size="mini" v-loading="adLoading"
                    :header-cell-style="{ background: '#fafafa', color: '#8c8c8c', fontWeight: 500, borderBottom: '1px solid #f0f0f0' }"
                    :cell-style="{ borderBottom: '1px solid #f5f5f5', color: '#262626' }">
                    <el-table-column prop="date" label="日期" width="100" />
                    <el-table-column label="广告位" min-width="110">
                        <template slot-scope="scope">{{ scope.row.ad_slot_name || adSlotName(scope.row.ad_slot) || '全部广告位' }}</template>
                    </el-table-column>
                    <el-table-column prop="income" label="收入(元)" width="90">
                        <template slot-scope="scope">{{ formatNumber((scope.row.income / 100).toFixed(2)) }}</template>
                    </el-table-column>
                    <el-table-column prop="ecpm" label="ecpm" width="105">
                        <template slot-scope="scope">{{ scope.row.ecpm.toFixed(2) }}</template>
                    </el-table-column>
                    <el-table-column prop="exposure_count" label="曝光次数" width="90">
                        <template slot-scope="scope">{{ formatNumber(scope.row.exposure_count) }}</template>
                    </el-table-column>
                    <el-table-column prop="exposure_rate" label="曝光率" width="80">
                        <template slot-scope="scope">{{ (scope.row.exposure_rate * 100).toFixed(2) }}%</template>
                    </el-table-column>
                    <el-table-column prop="click_count" label="点击次数" width="80">
                        <template slot-scope="scope">{{ formatNumber(scope.row.click_count) }}</template>
                    </el-table-column>
                    <el-table-column prop="click_rate" label="点击率" width="80">
                        <template slot-scope="scope">{{ (scope.row.click_rate * 100).toFixed(2) }}%</template>
                    </el-table-column>
                    <el-table-column prop="req_succ_count" label="请求成功" width="80">
                        <template slot-scope="scope">{{ formatNumber(scope.row.req_succ_count) }}</template>
                    </el-table-column>
                </el-table>
                <el-pagination small layout="total, sizes, prev, pager, next" :page-sizes="[10, 20]"
                    :page-size="adPageSize" :total="adTotal"
                    @current-change="handleAdPageChange" @size-change="handleAdSizeChange"
                    :current-page="adPage" class="dev-pagination" />

                <!-- 广告位明细（按广告单元汇总；微信的按天数据不带广告位字段，明细只在这个接口里有） -->
                <div class="ad-detail-head" v-if="adUnits.length">
                    <span class="ad-detail-title">广告位明细</span>
                    <span class="ad-detail-sub">按广告位/广告单元汇总，共 {{ adUnits.length }} 个</span>
                </div>
                <el-table v-if="adUnits.length" :data="adUnits" size="mini" class="ad-detail-table"
                    :header-cell-style="{ background: '#fafafa', color: '#8c8c8c', fontWeight: 500, borderBottom: '1px solid #f0f0f0' }"
                    :cell-style="{ borderBottom: '1px solid #f5f5f5', color: '#262626' }">
                    <el-table-column label="广告位" min-width="130">
                        <template slot-scope="scope">{{ scope.row.ad_slot_name || adSlotName(scope.row.ad_slot) || '未分类' }}</template>
                    </el-table-column>
                    <el-table-column label="广告单元" min-width="110" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.ad_unit_name || '未命名' }}</template>
                    </el-table-column>
                    <el-table-column label="广告位 ID" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.ad_slot_id || '—' }}</template>
                    </el-table-column>
                    <el-table-column label="收入(元)" width="100">
                        <template slot-scope="scope">{{ formatNumber((scope.row.income / 100).toFixed(2)) }}</template>
                    </el-table-column>
                    <el-table-column label="ecpm" width="95">
                        <template slot-scope="scope">{{ scope.row.ecpm.toFixed(2) }}</template>
                    </el-table-column>
                    <el-table-column label="曝光次数" width="95">
                        <template slot-scope="scope">{{ formatNumber(scope.row.exposure_count) }}</template>
                    </el-table-column>
                    <el-table-column label="点击次数" width="90">
                        <template slot-scope="scope">{{ formatNumber(scope.row.click_count) }}</template>
                    </el-table-column>
                    <el-table-column label="点击率" width="85">
                        <template slot-scope="scope">{{ (scope.row.click_rate * 100).toFixed(2) }}%</template>
                    </el-table-column>
                    <el-table-column label="请求成功" width="95">
                        <template slot-scope="scope">{{ formatNumber(scope.row.req_succ_count) }}</template>
                    </el-table-column>
                </el-table>
                <p class="ad-detail-note" v-if="adUnits.length && adUnitGap > 0.01">
                    明细合计 ¥{{ adUnitsTotal.toFixed(2) }}，与上方总收入相差 ¥{{ adUnitGap.toFixed(2) }}——这部分微信没有归到具体广告单元。
                </p>
            </div>

            <!-- 信息视图：广告位清单（只列有哪些广告位/单元，不带收益） -->
            <div v-show="adView === 'info'">
                <p class="ad-detail-sub" style="margin-bottom: 10px;">
                    统计范围 {{ (adDateRange && adDateRange[0]) || '-' }} 至 {{ (adDateRange && adDateRange[1]) || '-' }}，
                    共 {{ adUnits.length }} 个广告单元
                </p>
                <el-table :data="adUnits" size="mini" v-loading="adLoading"
                    :header-cell-style="{ background: '#fafafa', color: '#8c8c8c', fontWeight: 500, borderBottom: '1px solid #f0f0f0' }"
                    :cell-style="{ borderBottom: '1px solid #f5f5f5', color: '#262626' }">
                    <el-table-column label="广告位" min-width="140">
                        <template slot-scope="scope">{{ scope.row.ad_slot_name || adSlotName(scope.row.ad_slot) || '未分类' }}</template>
                    </el-table-column>
                    <el-table-column label="广告位 ID" min-width="170" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.ad_slot_id || '—' }}</template>
                    </el-table-column>
                    <el-table-column prop="ad_unit_name" label="广告单元" min-width="160" show-overflow-tooltip />
                    <el-table-column prop="ad_unit_id" label="单元 ID" min-width="200" show-overflow-tooltip />
                </el-table>
                <p class="ad-detail-note" v-if="!adUnits.length">该时间范围内没有广告单元数据。</p>
            </div>
        </div>
        </div>

        <!-- 图片上传对话框 -->
        <el-dialog title="扣除用户余额" :visible.sync="deductVisible" width="420px" append-to-body
            :close-on-click-modal="false" :close-on-press-escape="!deductPending" :show-close="!deductPending">
            <div v-if="deductTarget" class="deduct-summary">
                <strong>{{ deductTarget.username || '用户 ' + deductTarget.id }}</strong>
                <p>余额：¥{{ formatNumber(deductTarget.balance) }}　返利余额：¥{{ formatNumber(deductTarget.yqfl) }}</p>
                <p>本次金额将从余额和返利余额中各扣除一次，两项必须同时足额。</p>
                <el-input v-model="deductAmount" :disabled="deductPending" inputmode="decimal" placeholder="请输入本次扣除金额，最多两位小数"><template slot="append">元</template></el-input>
                <p>只能扣除，不能增加余额或直接设置账户金额。</p>
            </div>
            <span slot="footer"><el-button :disabled="deductPending" @click="deductVisible = false">取消</el-button><el-button type="danger" :loading="deductPending" @click="submitDeduction">确认扣除</el-button></span>
        </el-dialog>
        <el-dialog :title="image_set === 'kf' ? '设置客服图片' : '设置首页轮播图'" :visible.sync="image_set"
            custom-class="newdialog_share" @close="closeImageDialog">
            <div class="dev-upload-tip">
                <div>建议尺寸 <b>300 × 100</b>（宽 × 高），JPG / PNG / WEBP，单张不超过 10MB</div>
                <div>上传会自动压缩；<b>不设置则显示系统默认图</b></div>
            </div>
            <div class="dev-upload-list">
                <div v-for="(img, index) in image_list" :key="img + index" class="dev-upload-item">
                    <el-image class="dev-upload-thumb" :src="img" fit="cover" :preview-src-list="image_list" />
                    <div class="dev-upload-ops">
                        <el-button type="text" size="mini" :disabled="index === 0"
                            @click="moveImage(index, -1)">左移</el-button>
                        <el-button type="text" size="mini" :disabled="index === image_list.length - 1"
                            @click="moveImage(index, 1)">右移</el-button>
                        <el-button type="text" size="mini" style="color: #f56c6c;"
                            @click="removeImage(index)">删除</el-button>
                    </div>
                </div>
                <el-upload v-if="image_list.length < image_upload_num" action="#" :show-file-list="false"
                    accept="image/*" :http-request="uploadProxyImage" :before-upload="beforeAvatarUpload">
                    <div class="dev-upload-add" v-loading="image_uploading">
                        <i class="el-icon-plus"></i>
                    </div>
                </el-upload>
            </div>
            <div class="dev-upload-tip" v-if="image_set !== 'kf'">
                最多 {{ image_upload_num }} 张，顺序即小程序首页的轮播顺序
            </div>
            <span slot="footer">
                <el-button @click="image_set = false">取消</el-button>
                <el-button type="primary" :loading="image_saving" @click="confirmImageUpload">确定</el-button>
            </span>
        </el-dialog>

        <!-- 推广佣金设置对话框 -->
        <el-dialog title="推广佣金规则" :visible.sync="share_set" custom-class="newdialog_share">
            <div style="color: #ed6a0c; font-size: 13px; margin-bottom: 16px;">
                <div>10人及以下一二级总和不可超过25%</div>
                <div>200人及以下一二级总和不可超过35%</div>
                <div>200人及以上一二级总和不可超过45%</div>
            </div>
            <div class="dev-form-row">
                <div class="dev-form-label">等级名称</div>
                <el-input v-model="share_add.name" placeholder="输入名称" size="small" style="width: 240px;" />
            </div>
            <div class="dev-form-row">
                <div class="dev-form-label">生效人数</div>
                <el-input v-model="share_add.people" placeholder="输入人数" size="small" style="width: 240px;" />
            </div>
            <div class="dev-form-row">
                <div class="dev-form-label">一级返利</div>
                <el-input placeholder="百分百" v-model="share_add.share1" size="small" style="width: 120px;">
                    <template slot="append">%</template>
                </el-input>
            </div>
            <div class="dev-form-row">
                <div class="dev-form-label">二级返利</div>
                <el-input placeholder="百分百" v-model="share_add.share2" size="small" style="width: 120px;">
                    <template slot="append">%</template>
                </el-input>
            </div>
            <span slot="footer">
                <el-button @click="share_set = false" size="small">取消</el-button>
                <el-button type="primary" @click="addShareRule" size="small">添加</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getUserProfile } from '@/config/userProfile'

const COS = require('cos-js-sdk-v5')

export default {
    name: 'Developer',
    data() {
        return {
            // 权限状态
            hasPermission: false,
            activeSection: 'dashboard',
            sectionTabs: [
                { key: 'dashboard', name: '数据面板', icon: 'monitoring' },
                { key: 'info', name: '信息配置', icon: 'settings' },
                { key: 'cdk', name: '兑换码', icon: 'key' },
                { key: 'records', name: '记录列表', icon: 'receipt_long' },
                { key: 'ads', name: '广告列表', icon: 'ads_click' },
            ],

            // 代理信息
            proxy_info: {},
            balance: 0,
            rate: 1,

            // 记录列表
            recordRows: [],
            userKeyword: '',
            payKeyword: '',
            // 充值记录筛选：支付方式(1支付宝/2微信/0苹果内购)、状态(1已付款/0未付款)、日期范围
            payMethod: '',
            payStatus: '',
            payRange: [],
            deductionKeyword: '',
            deductVisible: false,
            deductPending: false,
            deductTarget: null,
            deductAmount: '',
            deductRequest: null,
            total: 0,
            recordPage: 1,
            pageSize: 8,
            activeName: 'user_list',
            loading: true,

            // 兑换码开通状态
            cdkActivated: false,
            cdkCanActivate: false,
            cdkActivating: false,

            // 推广佣金
            share_set: false,
            share_add: {
                name: '',
                people: 0,
                share1: 0,
                share2: 0,
            },

            // 图片上传
            image_set: false,
            image_list: [],
            image_uploading: false,
            image_saving: false,
            image_upload_num: 1,

            // 广告收益
            adList: [],
            adUnits: [],
            // 广告列表内的切换：income=广告收益(每日+明细) / info=广告信息(广告位清单)
            adView: 'income',
            // 广告接口出错时的提示（后端返回 status!=200 时显示，避免静默空表）
            adError: '',
            adSummary: null,
            adTotal: 0,
            adPage: 1,
            adPageSize: 10,
            adDateRange: ['2026-05-01', '2026-05-31'],
            adQuickDate: 'month',
            adLoading: false,
            adLoaded: false,
            adSource: '',
            adAppid: '',

            // 数据面板配置
            viewdata: [
                { color: '#0052d9', num_key: 'paytoday', name: '今日销售(元)' },
                { color: '#0052d9', num_key: 'paymonth', name: '本月销售(元)' },
                { color: '#0052d9', num_key: 'usernum', name: '用户数量' },
                { color: '#595959', num_key: 'paylastmonth', name: '上个月销售(元)' },
                { color: '#595959', num_key: 'payall', name: '总销售(元)' },
                { color: '#ed6a0c', num_key: 'ad_month', name: '广告本月收益(元)' },
                { color: '#ed6a0c', num_key: 'ad_yesterday', name: '广告昨日收益(元)' },
                { color: '#ed6a0c', num_key: 'ad_lastmonth', name: '广告上月收益(元)' },
            ],
        }
    },
    computed: {
        // 广告单元明细合计（分 → 元）
        adUnitsTotal() {
            return this.adUnits.reduce(function (sum, unit) {
                return sum + (unit.income || 0)
            }, 0) / 100
        },
        // 明细合计与总收入（summary）的差额：微信未归到具体广告单元的部分
        adUnitGap() {
            if (!this.adSummary) return 0
            return Math.max(0, this.adSummary.income / 100 - this.adUnitsTotal)
        },
        // 是否为兑换码代理
        isExchangeCodeProxy() {
            return this.proxy_info.app_name === '兑换码代理'
        },
        // 结算费率
        settlementRate() {
            return ((1 - (this.proxy_info.rate || 0)) * 100).toFixed(2)
        }
    },
    methods: {
        /**
         * 将当前代理后台视图同步到URL，便于刷新后恢复位置
         */
        updateViewQuery(section, tab) {
            const query = { ...this.$route.query, section }
            if (tab) {
                query.tab = tab
            } else {
                delete query.tab
            }
            this.$router.replace({ query }).catch(() => {})
        },

        /**
         * 从URL恢复代理后台视图
         */
        restoreViewFromQuery() {
            const sections = ['dashboard', 'info', 'cdk', 'records', 'ads']
            const tabs = ['user_list', 'pay_list', 'deduction_list']
            const querySection = this.$route.query.section
            const queryTab = this.$route.query.tab

            if (sections.indexOf(querySection) !== -1) {
                this.activeSection = querySection
            }
            if (tabs.indexOf(queryTab) !== -1) {
                this.activeName = queryTab
            }
        },

        switchSection(section) {
            this.activeSection = section
            this.updateViewQuery(section, section === 'records' ? this.activeName : '')
            if (section === 'ads' && !this.adLoaded) {
                this.getAdAll(1)
            }
            if (section === 'records') {
                this.handleTabClick({ name: this.activeName })
            }
        },

        /**
         * 跳转到独立的兑换码页面
         */
        goToBuyCdk() {
            this.$router.push('/buy-cdk')
        },

        /**
         * 查询兑换码开通状态（已开通 / 可自助开通）
         */
        getCdkStatus() {
            this.$ajax.get('api/v1/proxy/cdks/sellers').then(res => {
                const body = res.data || {}
                this.cdkActivated = (body.data || []).length > 0
                this.cdkCanActivate = !!body.can_activate
            }).catch(() => { })
        },

        /**
         * 自助开通兑换码权限
         */
        async activateCdk() {
            if (this.cdkActivating) return
            this.cdkActivating = true
            try {
                const res = await this.$ajax.post('api/v1/proxy/cdks/activate')
                if (!res.data || res.data.status !== 200) {
                    throw new Error((res.data && res.data.msg) || '开通失败')
                }
                this.$message.success((res.data && res.data.msg) || '开通成功')
                await this.getCdkStatus()
            } catch (error) {
                const msg = (error.response && error.response.data && error.response.data.detail)
                    || error.message || '开通失败'
                this.$message.error(msg)
            } finally {
                this.cdkActivating = false
            }
        },

        // ========== API 请求方法 ==========

        /**
         * 统一处理API响应
         */
        handleApiResponse(res, successCallback, errorCallback) {
            if (res.data && res.data.status === 200) {
                if (successCallback) successCallback(res.data)
            } else {
                const errorMsg = (res.data && res.data.msg) || '操作失败'
                this.$message.error(errorMsg)
                if (errorCallback) errorCallback(res.data)
            }
        },

        /**
         * 校验代理权限（新版本后台 v1/proxy/check，JWT鉴权，查 yh_proxy 表）
         */
        async checkProxyPermission() {
            try {
                const res = await this.$ajax.get('api/v1/proxy/check')
                if (res.data && res.data.status === 200) {
                    this.hasPermission = true
                }
                // 无权限时保持锁定状态，不额外弹窗
            } catch (error) {
                console.error('代理权限校验失败:', error)
            }
        },

        /**
         * 获取开发者信息
         */
        async getDeveloper() {
            try {
                const res = await this.$ajax.get('qhy/user/developer')
                this.handleApiResponse(
                    res,
                    (data) => {
                        if (data.developer) {
                            this.proxy_info = data.developer
                        } else {
                            this.showNoPermissionAlert()
                        }
                    },
                    () => {
                        this.showNoPermissionAlert()
                    }
                )
            } catch (error) {
                console.error('获取开发者信息失败:', error)
                this.showNoPermissionAlert()
            }
        },

        /**
         * 显示无权限提示（设为锁定状态）
         */
        showNoPermissionAlert() {
            this.hasPermission = false
        },

        /**
         * 读取 /me 缓存的账户余额
         */
        getAccountBalance(forceRefresh = false) {
            getUserProfile(this.$ajax, forceRefresh).then((data) => {
                this.balance = data && data.balance !== undefined ? data.balance : 0
            }).catch((error) => {
                console.error('获取账户余额失败:', error)
            })
        },

        /**
         * 获取用户记录
         */
        openDeductDialog(user) {
            this.deductTarget = user
            this.deductAmount = this.deductRequest && this.deductRequest.userId === user.id ? this.deductRequest.amount : ''
            this.deductVisible = true
        },
        async submitDeduction() {
            if (this.deductPending || !this.deductTarget) return
            const amount = this.deductAmount.trim()
            if (!/^(0|[1-9]\d*)(\.\d{1,2})?$/.test(amount) || Number(amount) <= 0) {
                this.$message.error('请输入大于 0 的金额，最多两位小数')
                return
            }
            if (Number(amount) > Math.min(Number(this.deductTarget.balance || 0), Number(this.deductTarget.yqfl || 0))) {
                this.$message.error('余额和返利余额必须同时足额')
                return
            }
            if (!this.deductRequest || this.deductRequest.userId !== this.deductTarget.id || this.deductRequest.amount !== amount) {
                const bytes = new Uint8Array(16)
                window.crypto.getRandomValues(bytes)
                const requestId = Array.from(bytes).map(value => ('0' + value.toString(16)).slice(-2)).join('')
                this.deductRequest = { userId: this.deductTarget.id, amount, request_id: requestId }
            }
            this.deductPending = true
            try {
                const res = await this.$ajax.post('api/v1/proxy/users/' + this.deductTarget.id + '/deduct', {
                    amount: this.deductRequest.amount, request_id: this.deductRequest.request_id
                })
                if (!res.data || res.data.status !== 200) throw new Error((res.data && res.data.msg) || '扣款未成功')
                this.$set(this.deductTarget, 'balance', res.data.balance)
                this.$set(this.deductTarget, 'yqfl', res.data.yqfl)
                this.deductRequest = null
                this.deductVisible = false
                this.$message.success(res.data.msg)
            } catch (error) {
                const body = error.response && error.response.data
                this.$message.error((body && (body.detail || body.msg)) || '扣款结果未确认，请重试，同一请求不会重复扣款')
            } finally {
                this.deductPending = false
            }
        },
        searchRecords() {
            this.recordPage = 1
            if (this.activeName === 'user_list') this.getUserOrder(1)
            else if (this.activeName === 'pay_list') this.getPayOrder(1)
            else if (this.activeName === 'deduction_list') this.getDeductionRecords(1)
        },
        async getUserOrder(page = 1) {
            this.loading = true
            try {
                const res = await this.$ajax.get('api/v1/proxy/users', { params: { page, page_size: this.pageSize, keyword: this.userKeyword.trim() } })
                this.handleApiResponse(res, (data) => {
                    this.recordRows = (data.data && data.data.data) || []
                    this.total = (data.data && data.data.total) || 0
                })
            } catch (error) {
                console.error('获取用户记录失败:', error)
            } finally {
                this.loading = false
            }
        },

        /**
         * 获取充值记录
         */
        async getDeductionRecords(page = 1) {
            this.loading = true
            try {
                const res = await this.$ajax.get('api/v1/proxy/users/deduction-records', { params: { page, page_size: this.pageSize, keyword: this.deductionKeyword.trim() } })
                this.handleApiResponse(res, data => {
                    this.recordRows = (data.data && data.data.data) || []
                    this.total = (data.data && data.data.total) || 0
                })
            } catch (error) {
                this.$message.error('获取扣款记录失败，请重试')
            } finally { this.loading = false }
        },
        async getPayOrder(page = 1) {
            this.loading = true
            try {
                const range = this.payRange && this.payRange.length === 2 ? this.payRange : []
                const res = await this.$ajax.get('api/v1/proxy/users/recharge-records', {
                    params: {
                        page,
                        page_size: this.pageSize,
                        keyword: this.payKeyword.trim(),
                        method: this.payMethod,
                        status: this.payStatus,
                        start_date: range[0] || '',
                        end_date: range[1] || '',
                    }
                })
                this.handleApiResponse(res, (data) => {
                    this.recordRows = (data.data && data.data.data) || []
                    this.total = (data.data && data.data.total) || 0
                })
            } catch (error) {
                console.error('获取充值记录失败:', error)
            } finally {
                this.loading = false
            }
        },
        // 支付方式文案：与后台充值订单页同一口径（1 支付宝 / 2 微信 / 0 苹果内购）
        payMethodName(method) {
            const value = Number(method)
            if (value === 1) return '支付宝'
            if (value === 2) return '微信'
            if (value === 0) return '苹果内购'
            return '其他'
        },
        resetPayFilters() {
            this.payKeyword = ''
            this.payMethod = ''
            this.payStatus = ''
            this.payRange = []
            this.searchRecords()
        },

        // ========== 图片上传相关 ==========

        /**
         * 打开图片上传对话框（homepage 多图 / kf 单图），带出已有图片
         */
        openImageUpload(type, limit) {
            this.image_set = type
            this.image_upload_num = limit
            if (type === 'kf') {
                this.image_list = this.proxy_info.kf ? [this.proxy_info.kf] : []
            } else {
                this.image_list = Array.isArray(this.proxy_info.homepage) ? this.proxy_info.homepage.slice() : []
            }
        },

        /**
         * 关闭图片上传对话框
         */
        closeImageDialog() {
            this.image_list = []
            this.image_uploading = false
            this.image_saving = false
        },

        removeImage(index) {
            this.image_list.splice(index, 1)
        },

        moveImage(index, delta) {
            const target = index + delta
            if (target < 0 || target >= this.image_list.length) return
            const tmp = this.image_list[index]
            this.$set(this.image_list, index, this.image_list[target])
            this.$set(this.image_list, target, tmp)
        },

        /**
         * 本地压缩：限宽 + JPEG 质量（与后台轮播图同一套做法）
         */
        compressImage(file, maxWidth, quality) {
            return new Promise(resolve => {
                if (!file || !/^image\//.test(file.type || '') || file.type === 'image/gif') {
                    resolve(null)
                    return
                }
                const objectUrl = URL.createObjectURL(file)
                const img = new Image()
                img.onload = () => {
                    URL.revokeObjectURL(objectUrl)
                    try {
                        const width = img.naturalWidth || img.width
                        const height = img.naturalHeight || img.height
                        if (!width || !height) {
                            resolve(null)
                            return
                        }
                        const scale = Math.min(1, maxWidth / width)
                        const targetW = Math.round(width * scale)
                        const targetH = Math.round(height * scale)
                        const canvas = document.createElement('canvas')
                        canvas.width = targetW
                        canvas.height = targetH
                        const ctx = canvas.getContext('2d')
                        // JPEG 不支持透明，先铺白底，免得 PNG 透明区变黑
                        ctx.fillStyle = '#ffffff'
                        ctx.fillRect(0, 0, targetW, targetH)
                        ctx.drawImage(img, 0, 0, targetW, targetH)
                        canvas.toBlob(blob => resolve(blob), 'image/jpeg', quality)
                    } catch (e) {
                        console.warn('[图片] 压缩失败，改用原图', e)
                        resolve(null)
                    }
                }
                img.onerror = () => {
                    URL.revokeObjectURL(objectUrl)
                    resolve(null)
                }
                img.src = objectUrl
            })
        },

        /**
         * 上传图片：本地压缩 → 要 COS 直传凭证 → 直传 qhy 桶（不经过服务器转发）
         */
        async uploadProxyImage(param) {
            const file = param.file
            this.image_uploading = true
            try {
                const blob = await this.compressImage(file, 900, 0.82)
                const compressed = blob && blob.size < file.size
                const body = compressed ? blob : file
                const filename = compressed ? file.name.replace(/\.[^.]+$/, '') + '.jpg' : file.name

                const res = await this.$ajax.post('api/v1/users/app-image/credential', { filename })
                const d = res.data && res.data.data
                if (!d || !d.Credentials) {
                    throw new Error((res.data && res.data.msg) || '获取上传密钥失败')
                }
                const cos = new COS({
                    SecretId: d.Credentials.TmpSecretId,
                    SecretKey: d.Credentials.TmpSecretKey,
                    SecurityToken: d.Credentials.Token,
                })
                await new Promise((resolve, reject) => {
                    cos.putObject({
                        Bucket: d.bucket,
                        Region: d.region,
                        Key: d.key,
                        Body: body,
                        ContentType: compressed ? 'image/jpeg' : (file.type || 'image/jpeg'),
                    }, (err, data) => {
                        if (err || !data || data.statusCode !== 200) {
                            reject(err || new Error('上传失败'))
                        } else {
                            resolve(data)
                        }
                    })
                })
                this.image_list.push(d.url)
                this.$message.success(compressed
                    ? ('上传成功（已压缩 ' + Math.round(file.size / 1024) + 'KB → ' + Math.round(body.size / 1024) + 'KB）')
                    : '上传成功')
            } catch (error) {
                const detail = error && error.response && error.response.data && error.response.data.detail
                this.$message.error(detail || (error && error.message) || '上传失败')
            } finally {
                this.image_uploading = false
            }
        },

        /**
         * 确认上传图片（整列表覆盖保存到 yh_proxy.homepage / kf）
         */
        async confirmImageUpload() {
            if (this.image_list.length === 0) {
                this.$message.warning('请至少上传一张图片')
                return
            }
            const data = {
                image_list: this.image_list,
                image_set: this.image_set
            }
            this.image_saving = true
            try {
                const res = await this.$ajax.post(
                    'qhy/proxyapp/image_set',
                    data,
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                this.handleApiResponse(res, () => {
                    this.$message.success('设置成功')
                    this.image_set = false
                    location.reload()
                })
            } catch (error) {
                console.error('保存图片失败:', error)
                this.$message.error('保存失败，请重试')
            } finally {
                this.image_saving = false
            }
        },

        /**
         * 图片上传前验证（压缩在 uploadProxyImage 里做，这里只挡格式与超大文件）
         */
        beforeAvatarUpload(file) {
            const allowTypes = ['image/jpeg', 'image/png', 'image/webp']
            if (allowTypes.indexOf(file.type) === -1) {
                this.$message.error('上传图片只能是 JPG / PNG / WEBP 格式!')
                return false
            }
            if (file.size / 1024 / 1024 >= 10) {
                this.$message.error('上传图片大小不能超过 10MB!')
                return false
            }
            return true
        },

        // ========== 推广佣金相关 ==========

        /**
         * 删除推广规则
         */
        async delShareRule(item) {
            try {
                const res = await this.$ajax.post(
                    'qhy/proxyapp/share_fl_del',
                    item,
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                this.handleApiResponse(res, () => {
                    this.$message.success('删除成功')
                    location.reload()
                })
            } catch (error) {
                console.error('删除推广规则失败:', error)
            }
        },

        /**
         * 添加推广规则
         */
        async addShareRule() {
            try {
                const res = await this.$ajax.post(
                    'qhy/proxyapp/share_fl_add',
                    this.share_add,
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                this.handleApiResponse(res, () => {
                    this.share_set = false
                    this.$message.success('添加成功')
                    // 重置表单
                    this.share_add = {
                        name: '',
                        people: 0,
                        share1: 0,
                        share2: 0,
                    }
                    location.reload()
                })
            } catch (error) {
                console.error('添加推广规则失败:', error)
            }
        },

        // ========== 广告收益相关 ==========

        /**
         * 获取广告收益列表
         */
        async getAdAll(page = 1) {
            this.adLoading = true
            try {
                const [startDate, endDate] = this.adDateRange || ['2026-05-01', '2026-05-31']
                const res = await this.$ajax.get('api/v1/proxy/ad-data', {
                    params: {
                        page,
                        page_size: this.adPageSize,
                        start_date: startDate,
                        end_date: endDate,
                        // 明细（广告位/广告单元）要多打一次微信接口，只有列表页需要
                        with_units: 1,
                    }
                })
                const responseData = res.data
                if (!responseData) {
                    this.adList = []
                    this.adUnits = []
                    this.adSummary = null
                    this.adTotal = 0
                    this.adError = '获取广告收益失败：响应为空'
                    return
                }
                // 后端业务错误（status != 200）原先被当成"没有数据"静默渲染，这里显示出来
                if (Number(responseData.status) !== 200) {
                    this.adList = []
                    this.adUnits = []
                    this.adSummary = null
                    this.adTotal = 0
                    this.adError = responseData.msg || responseData.detail || '获取广告收益失败'
                    return
                }
                const data = responseData.data || responseData
                this.adError = ''
                this.adList = data.list || []
                this.adUnits = data.units || []
                this.adSummary = data.summary || null
                this.adTotal = data.total_num || 0
                this.adSource = data.source || ''
                this.adAppid = data.appid || ''
                this.adLoaded = true
            } catch (error) {
                console.error('获取广告收益失败:', error)
                const body = error.response && error.response.data
                this.adList = []
                this.adUnits = []
                this.adSummary = null
                this.adTotal = 0
                this.adError = (body && (body.msg || body.detail)) || '获取广告收益失败'
            } finally {
                this.adLoading = false
            }
        },

        /**
         * 广告查询
         */
        handleAdSearch() {
            this.adPage = 1
            this.getAdAll(1)
        },

        /**
         * 快捷日期选择
         */
        setAdDateRange(type) {
            this.adQuickDate = type
            const now = new Date()
            const latestDate = new Date(now)
            latestDate.setDate(now.getDate() - 1)
            const pad = n => String(n).padStart(2, '0')
            const fmt = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`

            switch (type) {
                case 'yesterday':
                    this.adDateRange = [fmt(latestDate), fmt(latestDate)]
                    break
                case 'month': {
                    const firstDay = new Date(latestDate.getFullYear(), latestDate.getMonth(), 1)
                    this.adDateRange = [fmt(firstDay), fmt(latestDate)]
                    break
                }
                case 'lastMonth': {
                    const firstOfLast = new Date(now.getFullYear(), now.getMonth() - 1, 1)
                    const lastOfLast = new Date(now.getFullYear(), now.getMonth(), 0)
                    this.adDateRange = [fmt(firstOfLast), fmt(lastOfLast)]
                    break
                }
            }
            this.handleAdSearch()
        },

        /**
         * 获取广告本月/昨日/上月收益（用于顶部看板）
         */
        async fetchAdIncomeForDashboard() {
            const now = new Date()
            const latestDate = new Date(now)
            latestDate.setDate(now.getDate() - 1)
            const pad = n => String(n).padStart(2, '0')
            const fmt = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`

            // 昨天
            const yesterdayStr = fmt(latestDate)

            // 本月
            const firstDay = new Date(latestDate.getFullYear(), latestDate.getMonth(), 1)
            const monthStart = fmt(firstDay)
            const monthEnd = fmt(latestDate)

            // 上个月
            const firstOfLast = new Date(now.getFullYear(), now.getMonth() - 1, 1)
            const lastOfLast = new Date(now.getFullYear(), now.getMonth(), 0)
            const lastMonthStart = fmt(firstOfLast)
            const lastMonthEnd = fmt(lastOfLast)

            try {
                const [yRes, mRes, tRes] = await Promise.all([
                    this.$ajax.get('api/v1/proxy/ad-data', {
                        params: { start_date: yesterdayStr, end_date: yesterdayStr }
                    }),
                    this.$ajax.get('api/v1/proxy/ad-data', {
                        params: { start_date: lastMonthStart, end_date: lastMonthEnd }
                    }),
                    this.$ajax.get('api/v1/proxy/ad-data', {
                        params: { start_date: monthStart, end_date: monthEnd }
                    })
                ])
                const getIncome = (res) => {
                    const d = res.data
                    const data = d.data || d
                    return data.summary ? (data.summary.income / 100) : 0
                }
                this.$set(this.proxy_info, 'ad_yesterday', getIncome(yRes))
                this.$set(this.proxy_info, 'ad_lastmonth', getIncome(mRes))
                this.$set(this.proxy_info, 'ad_month', getIncome(tRes))
            } catch (error) {
                console.error('获取广告看板数据失败:', error)
            }
        },

        /**
         * 广告分页
         */
        handleAdPageChange(page) {
            this.adPage = page
            this.getAdAll(page)
        },

        /**
         * 广告每页条数变化
         */
        handleAdSizeChange(size) {
            this.adPageSize = size
            this.adPage = 1
            this.getAdAll(1)
        },

        /**
         * 广告位名称映射
         */
        adSlotName(slot) {
            const map = {
                'SLOT_ID_WEAPP_REWARD_VIDEO': '激励视频',
                'SLOT_ID_WEAPP_INTERSTITIAL': '插屏广告',
                'SLOT_ID_WEAPP_VIDEO_FEEDS': '视频广告',
                'SLOT_ID_WEAPP_VIDEO_BEGIN': '视频贴片',
                'SLOT_ID_WEAPP_TEMPLATE': '模板广告',
                'SLOT_ID_WEAPP_COVER': '封面广告',
                'SLOT_ID_WEAPP_BANNER': 'Banner广告',
            }
            return map[slot] || slot
        },

        // ========== 表格和分页相关 ==========

        /**
         * 标签页切换
         */
        handleTabClick(tab) {
            this.recordRows = []
            this.recordPage = 1
            this.updateViewQuery('records', tab.name)

            const tabMap = {
                'user_list': () => this.getUserOrder(),
                'pay_list': () => this.getPayOrder(),
                'deduction_list': () => this.getDeductionRecords(),
            }

            const handler = tabMap[tab.name]
            if (handler) {
                handler()
            }
        },

        /**
         * 分页变化
         */
        handlePageChange(page) {
            this.recordPage = page

            const tabMap = {
                'user_list': () => this.getUserOrder(page),
                'pay_list': () => this.getPayOrder(page),
                'deduction_list': () => this.getDeductionRecords(page),
            }

            const handler = tabMap[this.activeName]
            if (handler) {
                handler()
            }
        },

        /**
         * 格式化日期
         */
        formatDate(row) {
            if (!row.intime) return '-'
            const date = new Date(row.intime * 1000)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        },

        // ========== 工具方法 ==========

        /**
         * 格式化数字（添加千分位分隔符）
         */
        formatNumber(num) {
            if (num === null || num === undefined) return '0'
            const numValue = Number(num)
            if (isNaN(numValue)) return '0'

            // 如果是整数，不显示小数点
            if (numValue % 1 === 0) {
                return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }

            // 如果是小数，保留2位小数
            const numStr = numValue.toFixed(2)
            const parts = numStr.split('.')
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            return parts.join('.')
        },

        /**
         * 复制文本（使用现代 Clipboard API）
         */
        async copyText(text) {
            if (!text) {
                this.$message.warning('没有可复制的内容')
                return
            }

            try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(text)
                    this.$message.success('复制成功')
                } else {
                    // 降级方案
                    const textarea = document.createElement('textarea')
                    textarea.value = text
                    textarea.style.position = 'fixed'
                    textarea.style.opacity = '0'
                    document.body.appendChild(textarea)
                    textarea.select()
                    document.execCommand('copy')
                    document.body.removeChild(textarea)
                    this.$message.success('复制成功')
                }
            } catch (error) {
                console.error('复制失败:', error)
                this.$message.error('复制失败')
            }
        },
    },
    async created() {
        // 先校验代理权限（新版本后台 yh_proxy 表）
        await this.checkProxyPermission()
        if (!this.hasPermission) return

        this.restoreViewFromQuery()

        // 设置广告收益默认日期为本月第一天 ~ 昨天
        const now = new Date()
        const latestDate = new Date(now)
        latestDate.setDate(now.getDate() - 1)
        const firstDay = new Date(latestDate.getFullYear(), latestDate.getMonth(), 1)
        const pad = n => String(n).padStart(2, '0')
        this.adDateRange = [
            `${firstDay.getFullYear()}-${pad(firstDay.getMonth() + 1)}-${pad(firstDay.getDate())}`,
            `${latestDate.getFullYear()}-${pad(latestDate.getMonth() + 1)}-${pad(latestDate.getDate())}`
        ]
        this.getAccountBalance()
        this.getCdkStatus()
        if (this.activeSection === 'records') {
            this.handleTabClick({ name: this.activeName })
        } else {
            this.getUserOrder()
        }
        this.getDeveloper().then(() => {
            this.fetchAdIncomeForDashboard()
        })
    }
}
</script>

<style scoped>
.dev-container {
    padding: 20px;
    background: #f5f5f5;
    min-height: 100vh;
}

.dev-switch-cards {
    display: grid;
    grid-template-columns: repeat(5, minmax(120px, 1fr));
    gap: 12px;
    margin-bottom: 20px;
}

.dev-switch-hint {
    display: none;
}

.dev-switch-card {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 58px;
    padding: 0 14px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #ffffff;
    color: #64748b;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(30, 41, 59, .04);
    transition: all .2s ease;
}

.dev-switch-card:hover {
    color: #1a73e8;
    border-color: #bfdbfe;
    transform: translateY(-1px);
}

.dev-switch-card.active {
    color: #ffffff;
    border-color: #1a73e8;
    background: linear-gradient(135deg, #1a73e8, #0052ff);
    box-shadow: 0 8px 18px rgba(26, 115, 232, .22);
}

.dev-switch-card .app-icon {
    font-size: 20px;
}

.dev-panel {
    min-width: 0;
}

.dev-section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f1f1f;
    margin: 20px 0 12px 0;
    padding-left: 10px;
    border-left: 3px solid #0052d9;
    line-height: 1;
}

.dev-section-title:first-child {
    margin-top: 0;
}

/* 数据面板 - 卡片网格 */
.dev-stats-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
}

.dev-stat-card {
    background: #ffffff;
    border-radius: 8px;
    padding: 20px;
    border: 1px solid #e8e8e8;
}

.dev-stat-value {
    font-size: 28px;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 6px;
    font-variant-numeric: tabular-nums;
}

.dev-stat-label {
    font-size: 13px;
    color: #8c8c8c;
}

/* 通用卡片 */
.dev-card {
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    padding: 20px;
}

/* 信息行 */
.dev-info-row {
    display: flex;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f5f5f5;
}

.dev-info-row:first-child {
    padding-top: 0;
}

.dev-info-row:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.dev-info-label {
    width: 80px;
    flex-shrink: 0;
    font-size: 14px;
    color: #8c8c8c;
}

.dev-info-value {
    flex: 1;
    font-size: 14px;
    color: #1f1f1f;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.dev-highlight {
    font-size: 20px;
    font-weight: 600;
    color: #0052d9;
}

/* 状态圆点 */
.dev-status-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 6px;
    vertical-align: middle;
}

.dot-green { background: #00b578; }
.dot-gray { background: #bfbfbf; }

/* 图片 */
.dev-images {
    display: flex;
    align-items: center;
    gap: 10px;
}

.dev-thumb {
    width: 100px;
    height: 60px;
    border-radius: 4px;
    border: 1px solid #e8e8e8;
}

.dev-thumb-sm {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    border: 1px solid #e8e8e8;
}

/* 图片上传对话框 */
.dev-upload-tip {
    font-size: 13px;
    color: #8c8c8c;
    line-height: 1.7;
    margin-bottom: 10px;
}

.dev-upload-tip b {
    color: #0052d9;
}

.dev-upload-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.dev-upload-item {
    width: 140px;
}

.dev-upload-thumb {
    width: 140px;
    height: 60px;
    border-radius: 6px;
    border: 1px solid #e8e8e8;
    background: #fafafa;
}

.dev-upload-ops {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2px;
}

.dev-upload-add {
    width: 140px;
    height: 60px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8c8c8c;
    font-size: 22px;
    cursor: pointer;
    transition: all .2s;
}

.dev-upload-add:hover {
    border-color: #0052d9;
    color: #0052d9;
}

/* 推广佣金 - 卡片容器 */
.share-cards {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    width: 100%;
    min-width: 0;
}

/* 推广佣金 - 卡片 */
.share-card {
    background: #fafafa;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 10px 12px;
    box-sizing: border-box;
    width: 100%;
}

.share-card:last-child {
    margin-bottom: 0;
}

.share-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.share-card-name {
    font-size: 13px;
    font-weight: 600;
    color: #1f1f1f;
}

.share-card-body {
    display: grid;
    grid-template-columns: 1fr auto 1fr auto 1fr;
    align-items: center;
}

.share-stat {
    text-align: center;
}

.share-stat-value {
    display: block;
    font-size: 15px;
    font-weight: 600;
    color: #0052d9;
    line-height: 1.3;
}

.share-stat-label {
    font-size: 11px;
    color: #8c8c8c;
    margin-top: 1px;
}

.share-stat-divider {
    width: 1px;
    height: 26px;
    background: #e8e8e8;
    flex-shrink: 0;
}

.share-add-btn {
    margin-top: 4px;
}

@media (min-width: 900px) {
    .share-cards {
        grid-template-columns: repeat(2, 1fr);
    }
}

/* 表单 */
.dev-form-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}

.dev-form-row:last-of-type {
    margin-bottom: 0;
}

.dev-form-label {
    width: 80px;
    flex-shrink: 0;
    font-size: 14px;
    color: #595959;
}

.dev-tip {
    margin-top: 16px;
    font-size: 13px;
    color: #bfbfbf;
}

/* 链接 */
.dev-link {
    color: #0052d9;
    cursor: pointer;
}

.dev-link:hover {
    text-decoration: underline;
}

/* 标签 */
.dev-tag-blue {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 4px;
    background: #e8f0fe;
    color: #0052d9;
    font-size: 12px;
}

.dev-tag-gray {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 4px;
    background: #f5f5f5;
    color: #595959;
    font-size: 12px;
}

/* 搜索 */
.dev-search {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    margin-bottom: 12px;
}

/* 分页 */
.dev-pagination {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
}

/* 广告收益 - 统计摘要 */
.ad-summary {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 12px;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;
}

.ad-source {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    color: #64748b;
    font-size: 13px;
}

.ad-summary-item {
    text-align: center;
}

.ad-summary-value {
    font-size: 20px;
    font-weight: 600;
    color: #1f1f1f;
    line-height: 1.4;
    font-variant-numeric: tabular-nums;
}

.ad-summary-value.ad-income {
    color: #ed6a0c;
}

.ad-summary-label {
    font-size: 12px;
    color: #8c8c8c;
    margin-top: 4px;
}

/* 广告收益 - 查询区域 */
.ad-search {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

/* 广告收益 - 广告位明细 */
.ad-view-switch {
    margin: 12px 0 4px;
}

.ad-error {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 8px 0 4px;
    padding: 8px 12px;
    border: 1px solid #fde2e2;
    border-radius: 8px;
    background: #fef0f0;
    color: #f56c6c;
    font-size: 13px;
}

.ad-detail-head {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin: 18px 0 10px;
    padding-top: 14px;
    border-top: 1px solid #f0f0f0;
}

.ad-detail-title {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
}

.ad-detail-sub {
    font-size: 12px;
    color: #8c8c8c;
}

.ad-detail-table {
    margin-bottom: 4px;
}

.ad-detail-note {
    margin: 8px 0 0;
    font-size: 12px;
    line-height: 1.6;
    color: #8c8c8c;
}

/* 广告收益 - 快捷日期 */
.ad-quick-dates {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    flex-wrap: wrap;
    gap: 6px;
}

.ad-quick-label {
    font-size: 13px;
    color: #8c8c8c;
    white-space: nowrap;
}

/* 广告收益 - 响应式 */
@media (max-width: 768px) {
    .ad-summary {
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
    }
    .ad-summary-value {
        font-size: 16px;
    }
}

@media (max-width: 480px) {
    .ad-summary {
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
    }
    .ad-summary-value {
        font-size: 14px;
    }
    .ad-search {
        flex-wrap: wrap;
        gap: 8px;
    }
    .ad-search .el-date-picker {
        width: 100% !important;
    }
}

/* Tabs */
.dev-tabs >>> .el-tabs__header {
    margin: 0;
    background: #ffffff;
    border-radius: 8px 8px 0 0;
    padding: 0 20px;
    border: 1px solid #e8e8e8;
    border-bottom: none;
}

.dev-tabs >>> .el-tabs__nav-wrap::after {
    display: none;
}

.dev-tabs >>> .el-tabs__active-bar {
    background-color: #0052d9;
}

.dev-tabs >>> .el-tabs__item.is-active {
    color: #0052d9;
    font-weight: 500;
}

.dev-tabs >>> .el-tabs__content {
    padding: 0;
}

/* 响应式 */
@media (max-width: 768px) {
    .dev-stats-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
    }
    .dev-stat-card {
        padding: 14px;
    }
    .dev-stat-value {
        font-size: 22px;
    }
    .dev-container {
        padding: 14px;
    }
}

@media (max-width: 480px) {
    .dev-stats-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 6px;
    }
    .dev-stat-card {
        padding: 12px;
    }
    .dev-stat-value {
        font-size: 18px;
    }
    .dev-stat-label {
        font-size: 12px;
    }
    .share-card-body {
        flex-wrap: wrap;
        gap: 6px 0;
    }
    .share-stat {
        flex: 0 0 33.33%;
    }
    .share-stat-divider {
        display: none;
    }
    .share-stat-value {
        font-size: 13px;
    }
    .share-cards {
        grid-template-columns: 1fr;
    }
}

/* 无权限锁屏 */
.dev-lock {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 80vh;
}

.dev-lock-card {
    text-align: center;
    background: #fff;
    padding: 60px 50px;
    border-radius: 12px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
}

.dev-lock-card >>> .el-icon-lock {
    font-size: 64px;
    color: #bfbfbf;
}

.dev-lock-title {
    font-size: 22px;
    font-weight: 600;
    color: #1f1f1f;
    margin: 20px 0 10px;
}

.dev-lock-desc {
    font-size: 14px;
    color: #8c8c8c;
    margin-bottom: 30px;
}
/* 2.0 视觉统一 */
.dev-container {
    padding: 24px;
    background: #f5f7fa;
    color: #1e293b;
}

.dev-section-title {
    color: #1e293b;
    margin: 24px 0 14px;
    padding-left: 12px;
    border-left: 3px solid #1a73e8;
    line-height: 20px;
    letter-spacing: .2px;
}

.dev-section-title:first-child {
    margin-top: 0;
}

.dev-stats-grid {
    gap: 16px;
}

.dev-stat-card,
.dev-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(30, 41, 59, .04);
    transition: box-shadow .2s ease, transform .2s ease;
}

.dev-stat-card {
    padding: 20px;
}

.dev-stat-card:hover {
    box-shadow: 0 8px 20px rgba(30, 41, 59, .08);
    transform: translateY(-1px);
}

.dev-stat-value,
.dev-highlight {
    color: #1a73e8;
}

.dev-stat-label,
.dev-info-label,
.dev-tip,
.ad-summary-label {
    color: #64748b;
}

.dev-info-value {
    color: #1e293b;
}

.dev-info-row {
    border-bottom-color: #eef2f7;
}

.dev-thumb,
.dev-thumb-sm {
    border-color: #dbe4ef;
    border-radius: 8px;
}

.share-card {
    background: #f8fafc;
    border-color: #e2e8f0;
    border-radius: 10px;
}

.share-stat-value,
.dev-link {
    color: #1a73e8;
}

.dev-tag-blue {
    background: #e8f1ff;
    color: #1a73e8;
}

.dev-tag-gray {
    background: #f1f5f9;
    color: #64748b;
}

.dev-tabs >>> .el-tabs__header {
    border-color: #e2e8f0;
    border-radius: 12px 12px 0 0;
    padding: 0 24px;
}

.dev-tabs >>> .el-tabs__active-bar {
    background-color: #1a73e8;
}

.dev-tabs >>> .el-tabs__item.is-active {
    color: #1a73e8;
}

.dev-lock {
    min-height: 100%;
    padding: 24px;
    background: #f5f7fa;
}

.dev-lock-card {
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(30, 41, 59, .08);
}

.dev-lock-card >>> .el-icon-lock {
    color: #94a3b8;
}

.dev-lock-title {
    color: #1e293b;
}

@media (max-width: 768px) {
    .dev-switch-cards {
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
    }
    .dev-switch-card {
        height: 52px;
    }
    .dev-container {
        padding: 16px;
    }
}

@media (max-width: 480px) {
    .dev-switch-cards {
        display: flex;
        overflow-x: auto;
        margin-bottom: 6px;
        padding-bottom: 4px;
        scrollbar-width: none;
    }
    .dev-switch-cards::-webkit-scrollbar {
        display: none;
    }
    .dev-switch-card {
        min-width: 118px;
        flex-shrink: 0;
    }
    .dev-switch-hint {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 4px;
        margin: 0 4px 12px 0;
        color: #64748b;
        font-size: 12px;
    }
    .dev-container {
        padding: 12px;
    }
}

.deduct-summary strong { color:#0f172a; font-size:16px; }
.deduct-summary p { color:#64748b; font-size:13px; line-height:1.7; margin:12px 0; }

.record-search { display:flex; align-items:center; gap:10px; margin-bottom:16px; }
.record-search .el-input { width:320px; max-width:100%; }
.record-filters { display:flex; align-items:center; flex-wrap:wrap; gap:8px; margin:-8px 0 16px; }
@media(max-width:640px) { .record-search .el-input { width:auto; flex:1; min-width:0; } .record-search .el-button { margin-left:0; } }

.deduction-amount { color:#e45656; }
</style>


// WEBPACK FOOTER //
// src/components/User2/Developer.vue



// WEBPACK FOOTER //
// src/components/User2/Developer.vue